// extracted by mini-css-extract-plugin
module.exports = {"body":"HorsesList_body__SW0bY"};